/* ========================================================================
* DOM-based Routing
* Based on http://goo.gl/EUTi53 by Paul Irish
*
* Only fires on body classes that match. If a body class contains a dash,
* replace the dash with an underscore when adding it to the object below.
*
* .noConflict()
* The routing is enclosed within an anonymous function so that you can
* always reference jQuery with $, even when in .noConflict() mode.
* ======================================================================== */

/*global jQuery, Foundation, TE, google  */

import 'jquery';

import '../../node_modules/foundation-sites/dist/js/plugins/foundation.core.min.js';
import '../../node_modules/foundation-sites/dist/js/plugins/foundation.util.mediaQuery.min.js';
import '../../node_modules/foundation-sites/dist/js/plugins/foundation.util.imageLoader.min.js';
import '../../node_modules/foundation-sites/dist/js/plugins/foundation.util.keyboard.min.js';
import '../../node_modules/foundation-sites/dist/js/plugins/foundation.util.motion.min.js';
import '../../node_modules/foundation-sites/dist/js/plugins/foundation.util.timer.min.js';
import '../../node_modules/foundation-sites/dist/js/plugins/foundation.util.touch.min.js';
import '../../node_modules/foundation-sites/dist/js/plugins/foundation.equalizer.min.js';
import '../../node_modules/foundation-sites/dist/js/plugins/foundation.orbit.min.js';
import '../../node_modules/lightbox2/dist/js/lightbox.min.js';

(function($) {
	var App = {
		common: function() {
			$(document).foundation();

            App.featured_image.init();
            App.mobile_menu.init();

            $(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
                if( newSize !== oldSize ) {
                    App.featured_image.init();
                    App.mobile_menu.init();
                }
            });

            $('.menu-button').on('click', function(){
                if( $(this).hasClass('menu-open') ) {
                    $(this).removeClass('menu-open');
                    $('.mobile-menu-container').removeClass('toggled');
                    $(this).html('<span>☰</span>');
                } else {
                    $(this).addClass('menu-open');
                    $('.mobile-menu-container').addClass('toggled');
                    $('.menu-button').html('<span>✖</span>');
                }
            });

            $(window).on('resize', function() {
                $('.orbit-container').css('height', $('.orbit-container .is-active .responsive-image').height() );
            });
		},
        mobile_menu: {
			init: function () {
                if (Foundation.MediaQuery.is('small only')) {
					this.mobileMenu();
				} else {
					this.desktopMenu();
				}
			},

			mobileMenu: function () {
				if( $('.mobile-menu-container #menu-main-menu').length ) {
					return false;
				}

				$('#menu-main-menu').appendTo('.mobile-menu-container');
			},

			desktopMenu: function () {
				if( !$('.mobile-menu-container #menu-main-menu').length ) {
					return false;
				}

				$('#menu-main-menu').appendTo('.desktop-menu-container');
			}
		},
        featured_image: {
            init: function() {
                $('div.responsive-image').each(function () {
                    if (Foundation.MediaQuery.is('small only')) {
                        if( $(this).attr('data-mobile-url') ) {
                            $(this).css('background', 'url("' + $(this).attr('data-mobile-url') + '") center no-repeat');
                            $(this).css('background-size', 'cover');
                        }
                    }

                    if (Foundation.MediaQuery.is('medium only')) {
                        if( $(this).attr('data-tablet-url') ) {
                            $(this).css('background', 'url("' + $(this).attr('data-tablet-url') + '") center no-repeat');
                            $(this).css('background-size', 'cover');
                        }
                    }

                    if (Foundation.MediaQuery.atLeast('large')) {
                        if( $(this).attr('data-desktop-url') ) {
                            $(this).css('background', 'url("' + $(this).attr('data-desktop-url') + '") center no-repeat');
                            $(this).css('background-size', 'cover');
                        }
                    }
                });

                $('img.responsive-image').each(function () {
                    if (Foundation.MediaQuery.is('small only')) {
                        if( $(this).attr('data-mobile-url') ) {
                            $(this).attr('src', $(this).attr('data-mobile-url'));
                        }
                    }

                    if (Foundation.MediaQuery.is('medium only')) {
                        if( $(this).attr('data-tablet-url') ) {
                            $(this).attr('src', $(this).attr('data-tablet-url'));
                        }
                    }

                    if (Foundation.MediaQuery.atLeast('large')) {
                        if( $(this).attr('data-desktop-url') ) {
                            $(this).attr('src', $(this).attr('data-desktop-url'));
                        }
                    }
                });
            }
        },
        location_map: {
            init: function() {
                var map = new google.maps.Map(document.getElementById('google_map'), {
                    zoom: 10,
                    styles: [
                      {
                        'elementType': 'geometry',
                        'stylers': [
                          {
                            'color': '#f5f5f5'
                          }
                        ]
                      },
                      {
                        'elementType': 'labels.icon',
                        'stylers': [
                          {
                            'visibility': 'off'
                          }
                        ]
                      },
                      {
                        'elementType': 'labels.text.fill',
                        'stylers': [
                          {
                            'color': '#616161'
                          }
                        ]
                      },
                      {
                        'elementType': 'labels.text.stroke',
                        'stylers': [
                          {
                            'color': '#f5f5f5'
                          }
                        ]
                      },
                      {
                        'featureType': 'administrative.land_parcel',
                        'stylers': [
                          {
                            'visibility': 'off'
                          }
                        ]
                      },
                      {
                        'featureType': 'administrative.land_parcel',
                        'elementType': 'labels.text.fill',
                        'stylers': [
                          {
                            'color': '#bdbdbd'
                          }
                        ]
                      },
                      {
                        'featureType': 'administrative.locality',
                        'elementType': 'labels.text',
                        'stylers': [
                          {
                            'color': '#000000'
                          }
                        ]
                      },
                      {
                        'featureType': 'administrative.locality',
                        'elementType': 'labels.text.fill',
                        'stylers': [
                          {
                            'color': '#000000'
                          }
                        ]
                      },
                      {
                        'featureType': 'administrative.locality',
                        'elementType': 'labels.text.stroke',
                        'stylers': [
                          {
                            'color': '#FFFFFF'
                          },
                          {
                            'weight': 4
                          }
                        ]
                      },
                      {
                        'featureType': 'administrative.neighborhood',
                        'stylers': [
                          {
                            'visibility': 'off'
                          }
                        ]
                      },
                      {
                        'featureType': 'poi',
                        'elementType': 'geometry',
                        'stylers': [
                          {
                            'color': '#eeeeee'
                          }
                        ]
                      },
                      {
                        'featureType': 'poi',
                        'elementType': 'labels.text',
                        'stylers': [
                          {
                            'visibility': 'off'
                          }
                        ]
                      },
                      {
                        'featureType': 'poi',
                        'elementType': 'labels.text.fill',
                        'stylers': [
                          {
                            'color': '#757575'
                          }
                        ]
                      },
                      {
                        'featureType': 'poi.business',
                        'stylers': [
                          {
                            'visibility': 'off'
                          }
                        ]
                      },
                      {
                        'featureType': 'poi.park',
                        'elementType': 'geometry',
                        'stylers': [
                          {
                            'color': '#e5e5e5'
                          }
                        ]
                      },
                      {
                        'featureType': 'poi.park',
                        'elementType': 'labels.text.fill',
                        'stylers': [
                          {
                            'color': '#9e9e9e'
                          }
                        ]
                      },
                      {
                        'featureType': 'road',
                        'elementType': 'geometry',
                        'stylers': [
                          {
                            'color': '#ffffff'
                          }
                        ]
                      },
                      {
                        'featureType': 'road',
                        'elementType': 'labels',
                        'stylers': [
                          {
                            'visibility': 'off'
                          }
                        ]
                      },
                      {
                        'featureType': 'road',
                        'elementType': 'labels.icon',
                        'stylers': [
                          {
                            'visibility': 'off'
                          }
                        ]
                      },
                      {
                        'featureType': 'road.arterial',
                        'elementType': 'geometry.fill',
                        'stylers': [
                          {
                            'color': '#008BD2'
                          },
                          {
                            'weight': 2
                          }
                        ]
                      },
                      {
                        'featureType': 'road.arterial',
                        'elementType': 'geometry.stroke',
                        'stylers': [
                          {
                            'visibility': 'off'
                          }
                        ]
                      },
                      {
                        'featureType': 'road.arterial',
                        'elementType': 'labels.text.fill',
                        'stylers': [
                          {
                            'color': '#757575'
                          }
                        ]
                      },
                      {
                        'featureType': 'road.highway',
                        'elementType': 'geometry',
                        'stylers': [
                          {
                            'color': '#dadada'
                          }
                        ]
                      },
                      {
                        'featureType': 'road.highway',
                        'elementType': 'geometry.fill',
                        'stylers': [
                          {
                            'color': '#831F82'
                          },
                          {
                            'weight': 4
                          }
                        ]
                      },
                      {
                        'featureType': 'road.highway',
                        'elementType': 'geometry.stroke',
                        'stylers': [
                          {
                            'visibility': 'off'
                          }
                        ]
                      },
                      {
                        'featureType': 'road.highway',
                        'elementType': 'labels.text.fill',
                        'stylers': [
                          {
                            'color': '#616161'
                          }
                        ]
                      },
                      {
                        'featureType': 'road.local',
                        'elementType': 'labels.text.fill',
                        'stylers': [
                          {
                            'color': '#9e9e9e'
                          }
                        ]
                      },
                      {
                        'featureType': 'transit',
                        'stylers': [
                          {
                            'visibility': 'off'
                          }
                        ]
                      },
                      {
                        'featureType': 'transit.line',
                        'elementType': 'geometry',
                        'stylers': [
                          {
                            'color': '#e5e5e5'
                          }
                        ]
                      },
                      {
                        'featureType': 'transit.station',
                        'elementType': 'geometry',
                        'stylers': [
                          {
                            'color': '#eeeeee'
                          }
                        ]
                      },
                      {
                        'featureType': 'water',
                        'elementType': 'geometry',
                        'stylers': [
                          {
                            'color': '#c9c9c9'
                          }
                        ]
                      },
                      {
                        'featureType': 'water',
                        'elementType': 'labels.text',
                        'stylers': [
                          {
                            'visibility': 'off'
                          }
                        ]
                      },
                      {
                        'featureType': 'water',
                        'elementType': 'labels.text.fill',
                        'stylers': [
                          {
                            'color': '#9e9e9e'
                          }
                        ]
                      }
                    ]
                }),
                new_loc = new google.maps.LatLng(parseFloat($('.marker').attr('data-lat')), parseFloat($('.marker').attr('data-lng'))),
                bounds = new google.maps.LatLngBounds(),
                towns = [
                    ['Oxford', 51.752021, -1.257726, 3],
                    ['Swindon', 51.555774, -1.779718, 2],
                    ['Newbury', 51.401409, -1.323114, 1]
                ];

                App.location_map.createMarkers(map);

                for (var i = 0; i < towns.length; i++) {
                    var town = towns[i],
                        myLatLng = new google.maps.LatLng(town[1], town[2]);
                    bounds.extend(myLatLng);
                }

                map.panTo(new_loc);
                map.fitBounds(bounds);


            },
            createMarkers: function(map) {
                var icon_base = TE.theme_url + '/assets/images/';
                $('.marker').each( function () {
                    var map_icon = 'map-pin.png',
                        latitude = $(this).attr('data-lat'),
                        longitude = $(this).attr('data-lng'),
                        marker_position = {lat: parseFloat(latitude), lng: parseFloat(longitude)},
                        marker = new google.maps.Marker({
                            position: marker_position,
                            map: map,
                            icon: icon_base + map_icon
                        });

                    marker.setMap(map);
                });
            }
        }
    };

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Router = {
		// All pages
		'common': {
			init: function() {
				// JavaScript to be fired on all pages
				App.common();
			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},
    'home': {
      finalize: function() {
        $('.orbit-container').css('height', $('.orbit-container .is-active .responsive-image').height() );
      }
    },
    'page_template_template_location_page': {
      init: function() {
				App.location_map.init();
			}
    },
    'page_template_template_contact_page': {
      init: function() {
				App.location_map.init();
			}
    },
		'page_template_landing_page': {
			init: function() {
				var form = $('.gform_wrapper'),
	          formLabel = form.find('.gfield_label'),
	          inputFind = $('input[type="email"], input[type="text"], textarea'),
	          formInputs = form.find(inputFind),
	          inputContainer = '.ginput_container';

	      $(formLabel).on('click', function () {
	        var $this = $(this);
	        $this.hide();
	        $this.prev(inputContainer).find(formInputs).focus();
	      });

	      $(formInputs)
	        .focus(function () {
	          $(this).closest(inputContainer).prev('.gfield_label').hide();
	        })
	        .blur(function () {
	          if ($(this).val() === '') {
	              $(this).closest(inputContainer).prev('.gfield_label').show();
	          }
	        });


	      $(formInputs).each(function () {
	        if ($(this).val() !== '') {
	          $(this).closest(inputContainer).prev('.gfield_label').hide();
	        }
	      });
			}
		}
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function(func, funcname, args) {
			var fire;
			var namespace = Router;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
